import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import { TextArea } from "atoms/TextArea";

import { QuizStepProps } from "../useQuestionnaire";

import YesNo from "./components/YesNo";

export const OpiateMedications = (props: QuizStepProps) => {
  const hasError = !!props.errors?.OpiateMedications;
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("OpiateMedicationsQuestion", value);
    props.handleStepData("OpiateMedications", "");
    if (value === "No") {
      setLastUpdate({ key: "OpiateMedicationsQuestion", value });
    }
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex h-full flex-col">
      <p className="pb-4 font-serif text-h3">
        Are you currently taking, plan to take, or have recently (within the
        last 3 months) taken opiate pain medications and/or opiate-based street
        drugs? If so, please include date range, name, dose, and frequency.
      </p>
      <div className="flex gap-3">
        <YesNo
          value={props.data.OpiateMedicationsQuestion}
          onChange={(value) => handleChange(value)}
        />
      </div>
      <div
        hidden={props.data.OpiateMedicationsQuestion !== "Yes"}
        className="mt-4"
      >
        <TextArea
          label="Opiate Medications"
          value={props.data.OpiateMedications as string}
          invalid={hasError}
          onChange={(value) => props.handleStepData("OpiateMedications", value)}
        />
        {hasError && (
          <p className="mt-2 text-sm text-red">
            Please add information requested above.
          </p>
        )}
      </div>
      <div
        hidden={props.data.OpiateMedicationsQuestion !== "Yes"}
        className="mt-auto"
      >
        <Button fullWidth onClick={() => props.next?.()}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
